var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.87 4.313a2.85 2.85 0 0 0-4.031 0L5.123 13.03c-.43.43-.71.985-.802 1.585l-.354 2.318a2.85 2.85 0 0 0 3.247 3.248l2.318-.354a2.85 2.85 0 0 0 1.585-.802l8.716-8.717a2.85 2.85 0 0 0 0-4.03L17.87 4.313ZM15.04 5.515a1.15 1.15 0 0 1 1.626 0l1.964 1.964c.45.45.45 1.177 0 1.626L17.237 10.5l-3.59-3.59 1.394-1.394Zm-2.596 2.596-6.12 6.12a1.15 1.15 0 0 0-.324.64l-.354 2.318a1.15 1.15 0 0 0 1.31 1.31l2.318-.354a1.15 1.15 0 0 0 .64-.323l6.12-6.12-3.59-3.59Z",
    fill: "currentColor"
  })));
};
export default SvgPen;